module.exports = __webpack_public_path__ + "static/berufsmantelChestPocketLogo-8b2bb020db9ccac4a95fa10c80fc593b.jpg";